const MinusIcon = props => (
  <svg viewBox='0 0 24 24' {...props}>
    <title>subtract-normal-c</title>
    <g>
      <path d='M21.6 12c0-5.3-4.3-9.6-9.6-9.6S2.4 6.7 2.4 12M0 12C0 5.4 5.4 0 12 0s12 5.4 12 12M2.4 12c0 5.3 4.3 9.6 9.6 9.6s9.6-4.3 9.6-9.6m2.4 0c0 6.6-5.4 12-12 12S0 18.6 0 12' />
      <path d='M6 13h12v-2H6z' />
    </g>
  </svg>
)

export default MinusIcon
